// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"_breadcrumbsCustom_breadcrumbs__lYsXg"};